<template>
  <v-container
    id="faq-list"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          icon="mdi-frequently-asked-questions"
        >
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('faq.faqlist') }}
            </div>
          </template>
          <template #after-heading-right>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="searchText"
                class="purple-input"
                :label="$t('faq.search')"
              />
            </v-col>
          </template>
          <v-tabs
            v-model="tab"
          >
            <v-tab>
              {{ $t('faq.tabger') }}
            </v-tab>
            <v-tab>
              {{ $t('faq.taben') }}
            </v-tab>
            <v-tab>
              {{ $t('faq.tabes') }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <faq
                :faqs="faqs"
                :tab="tab"
                :search-text="searchText"
                @request-load-faqs="loadFaqs"
              />
            </v-tab-item>
            <v-tab-item>
              <faq
                :faqs="faqs"
                :tab="tab"
                :search-text="searchText"
                @request-load-faqs="loadFaqs"
              />
            </v-tab-item>
            <v-tab-item>
              <faq
                :faqs="faqs"
                :tab="tab"
                :search-text="searchText"
                @request-load-faqs="loadFaqs"
              />
            </v-tab-item>
          </v-tabs-items>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Faq from './components/faq.vue'
  import { fetchFaq } from '@/firebase'
  export default {
    components: { Faq },
    data: () => ({
      tab: 0,
      faqs: [],
      searchText: '',
    }),
    mounted () {
      this.loadFaqs()
    },
    methods: {
      loadFaqs () {
        fetchFaq().then(results => {
          this.faqs = results
        })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>
